import { ItemSelect } from './../modelos/itemselect';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class CatalogoService {

  constructor( private firestore: AngularFirestore) { }

  getTiposOperacion() {
    let tiposOperacion: ItemSelect[] = [
      {value: '0', description: 'Exportación'},
      {value: '1', description: 'Importación temporal'},
      {value: '2', description: 'Importación definitiva'},
      {value: '3', description: 'Operaciones especiales'},
    ];

    return tiposOperacion;
  }

  getAduanas() {
    return this.firestore.collection("aduanas").snapshotChanges();
  }

  getTransportes(idAduana:string) {
    return this.firestore.collection("aduanatransportes", ref => ref.where('Aduana', '==', idAduana)).snapshotChanges();
  }

  getHonorarios(tipoOperacion: number) {
    return this.firestore.collection('servicios', ref => ref.where('TipoOperacion', '==', tipoOperacion).where('TipoTabulador', '==', 0)).snapshotChanges();
  }

  getOtrosServicios(tipoOperacion: number) {
    return this.firestore.collection("servicios", ref => ref.where('TipoOperacion', '==', tipoOperacion).where('TipoTabulador', '==', 1)).snapshotChanges();
  }

  guardarCotizacion(datos: any){
    this.firestore.collection('cotizaciones').add(datos);
  }
}
